export default __webpack_public_path__ + "static/media/bannerBg.809d6270.png";